import styled from "styled-components";

export const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 1040;
  font-family: "Noto Sans", system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  .site-header__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    min-height: 58px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .site-header__shell {
    background: #070a12;
    border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  }

  .site-header__brand {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    text-decoration: none;
    line-height: 0;

    img {
      width: auto;
      max-width: min(170px, 52vw);
      height: 30px;
      object-fit: contain;
    }

    @media (min-width: 768px) {
      img {
        max-width: 180px;
        height: 30px;
      }
    }

    @media (min-width: 992px) {
      img {
        max-width: 208px;
        height: 34px;
      }
    }
  }

  .site-header__nav {
    align-items: center;
    gap: 0.125rem;
    flex: 1;
    justify-content: center;
    max-width: 480px;
    margin: 0 auto;
  }

  .site-header__link {
    display: inline-flex;
    align-items: center;
    padding: 0.42rem 0.55rem;
    margin: 0 0.35rem;
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    color: rgba(203, 213, 225, 0.88);
    text-decoration: none;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid transparent;
    background: transparent;
    transition: color 0.15s ease, border-color 0.15s ease;

    &:hover {
      color: #f1f5f9;
    }

    &.is-active {
      color: #f8fafc;
      font-weight: 600;
      border-bottom-color: #818cf8;
      background: transparent;
      box-shadow: none;
    }
  }

  .site-header__cta {
    flex-shrink: 0;
  }

  .site-header__btn {
    appearance: none;
    border: 1px solid rgba(148, 163, 184, 0.45);
    background: transparent;
    color: #e2e8f0;
    font-family: inherit;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0.5rem 0.92rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: rgba(99, 102, 241, 0.15);
      border-color: rgba(129, 140, 248, 0.55);
      color: #fff;
    }

    &:active {
      transform: translateY(1px);
    }
  }

  .site-header__toggle {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 4px;
    background: transparent;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
      background: rgba(30, 41, 59, 0.5);
      border-color: rgba(148, 163, 184, 0.5);
    }
  }

  .site-header__toggle-bar {
    display: block;
    width: 16px;
    height: 2px;
    margin: 0 auto;
    background: #cbd5e1;
    border-radius: 1px;
  }

  .site-header__drawer {
    width: min(300px, 90vw);
    background: #070a12;
    border-left: 1px solid rgba(148, 163, 184, 0.15);
    color: #e2e8f0;
  }

  .site-header__drawer .offcanvas-header {
    border-bottom: 1px solid rgba(148, 163, 184, 0.12);
    padding: 0.85rem 1rem;
  }

  .site-header__drawer-title {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(148, 163, 184, 0.95);
  }

  .site-header__drawer-nav {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding-top: 0.25rem;
  }

  .site-header__drawer-link {
    display: block;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(226, 232, 240, 0.92);
    text-decoration: none;
    border-radius: 0;
    border-left: 3px solid transparent;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: rgba(30, 41, 59, 0.35);
      color: #f8fafc;
    }

    &.is-active {
      background: transparent;
      color: #fff;
      font-weight: 600;
      border-left-color: #818cf8;
    }
  }

  .site-header__drawer-cta {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(148, 163, 184, 0.12);
  }

  .site-header__drawer-cta .site-header__btn {
    width: 100%;
    text-align: center;
  }
`;
